import { render, staticRenderFns } from "./CommissionAccountChart.vue?vue&type=template&id=4df3255b&scoped=true"
import script from "./CommissionAccountChart.vue?vue&type=script&lang=js"
export * from "./CommissionAccountChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df3255b",
  null
  
)

export default component.exports